import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-area clear-both mb-0 mt-3">
            <div className="copyRight text-center text-white">
                <p className="pt-3">Designed and Developed By <span className="text-warning">Moon Saha Chowdhury</span></p>
                <ul className="social-media list-inline">
                    <li className="list-inline-item"><a href="https://github.com/moon-saha-chowdhury" target="_blank"><FontAwesomeIcon className="icon active-icon" icon={faGithub} /></a></li>
                    <li className="list-inline-item"><a href="https://www.linkedin.com/in/moon-saha-chowdhury-aa00a2211/" target="_blank"><FontAwesomeIcon className="icon" icon={faLinkedin} /></a></li>
                    <li className="list-inline-item"><a href="https://mail.google.com/mail/u/0/" target="_blank"><FontAwesomeIcon className="icon" icon={faEnvelope} /></a></li>
                </ul>
                <p>Copyright {(new Date()).getFullYear()} All Rights Reserved</p>
            </div>

        </footer>
    );
};

export default Footer;